const ID_TOKEN_KEY = "config" as string;

export function getToken(): string | null {
  return window.sessionStorage.getItem(ID_TOKEN_KEY);
}

export function saveToken(token: string): void {
  window.sessionStorage.setItem(ID_TOKEN_KEY, token);
}

export function destroyToken(): void {
  window.sessionStorage.removeItem(ID_TOKEN_KEY);
}

export default { getToken, saveToken, destroyToken };
